import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import { Contacts as ContactsIcon } from '@material-ui/icons';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { usePatientManyDups } from 'requests/resources/patient';

import { Button, ButtonProps } from './Button';
import DialogPatientMerge from './DialogPatientMerge';
import { SvgIconWrapper, SvgIconWrapperProps } from './SvgIconWrapper';

const styles = () =>
  createStyles({
    root: {
      // TODO remove once the `borderRadius` is overriden from MUI theme
      borderRadius: 4,
    },
  });

const messages = defineMessages({
  label: {
    id: 'components.v2.ButtonPatientMerge.label',
    defaultMessage: '{count, plural, one {Review # duplicate} other {Review # duplicates}}',
  },
  labelMore: {
    id: 'components.v2.ButtonPatientMerge.labelMore',
    defaultMessage: 'Review Duplicates',
  },
});

const maxDups = 5;

export interface ButtonPatientMergeProps extends Omit<ButtonProps, 'classes' | 'onClick'>, WithStyles<typeof styles> {
  patientId: string;
  svgIconWrapperProps?: Partial<SvgIconWrapperProps>;
}

const ButtonPatientMerge: React.FC<ButtonPatientMergeProps> = ({
  classes,
  className,
  children,
  patientId,
  svgIconWrapperProps,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);
  const { data } = usePatientManyDups(patientId);

  return (
    <>
      {data && !isEmpty(data) && (
        <Button
          data-lh-id="LumaButtonPatientMerge-btn"
          className={classnames(classes.root, className)}
          icon={<SvgIconWrapper Icon={ContactsIcon} {...svgIconWrapperProps} />}
          onClick={() => setOpen(true)}
          {...rest}
        >
          {children || data.length >= maxDups
            ? formatMessage(messages.labelMore)
            : formatMessage(messages.label, { count: data.length })}
        </Button>
      )}
      <DialogPatientMerge
        open={open}
        patient={patientId}
        patientDups={data ? data.slice(0, maxDups) : []}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default withStyles(styles, { name: 'LumaButtonPatientMerge' })(ButtonPatientMerge);
